import React from 'react';
import { ExternalLink } from 'lucide-react';

export default function ProjectsSection({ projects }) {
  return (
    <section id="projects" className="py-20">
      <h2 className="text-4xl md:text-5xl font-black mb-16 text-center">
        <span className="bg-gradient-to-r from-purple-400 to-cyan-400 text-transparent bg-clip-text">Избранные проекты</span>
      </h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {projects.map((project) => {
          const Icon = project.icon;

          return (
            <div
              key={project.id}
              className="group relative p-8 bg-white/5 backdrop-blur-md rounded-3xl border border-white/10 hover:border-white/30 transition-all duration-500 hover:scale-105"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${project.color} opacity-0 group-hover:opacity-10 rounded-3xl transition-opacity duration-500`} />
              <div className="relative">
                <div className={`inline-block p-4 bg-gradient-to-br ${project.color} rounded-2xl mb-6 shadow-lg`}>
                  <Icon className="text-white" size={32} />
                </div>
                <h3 className="text-2xl font-bold mb-3 text-white">{project.name}</h3>
                <p className="text-gray-400 mb-6 leading-relaxed">{project.description}</p>
                <div className="flex flex-wrap gap-2 mb-6">
                  {project.tech.map((tech) => (
                    <span key={`${project.id}-${tech}`} className="px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm border border-white/20">
                      {tech}
                    </span>
                  ))}
                </div>

                {project.url ? (
                  <a
                    href={project.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`inline-flex items-center gap-2 font-semibold bg-gradient-to-r ${project.color} text-transparent bg-clip-text hover:scale-105 transition-transform`}
                  >
                    Открыть <ExternalLink size={16} />
                  </a>
                ) : (
                  <span className={`inline-flex items-center gap-2 font-semibold bg-gradient-to-r ${project.color} text-transparent bg-clip-text`}>
                    Подробнее <ExternalLink size={16} />
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
